var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.checkedPhone)?_c('pageIndex'):_c('views')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }